(() => {
class $b91d5439a3929dc1$var$InstitutionCarrossel {
    constructor(){
        this.handleCarrossel();
    }
    handleCarrossel() {
        const carousel = document.getElementById("wp-parresia-register-carrossel-list");
        const prevButton = document.getElementById("wp-parresia-carrossel-left");
        const nextButton = document.getElementById("wp-parresia-carrossel-right");
        const scrollAmount = 240;
        prevButton.addEventListener("click", ()=>{
            carousel.scrollBy({
                left: -scrollAmount,
                behavior: "smooth"
            });
        });
        nextButton.addEventListener("click", ()=>{
            carousel.scrollBy({
                left: scrollAmount,
                behavior: "smooth"
            });
        });
    }
}
document.addEventListener("DOMContentLoaded", ()=>{
    new $b91d5439a3929dc1$var$InstitutionCarrossel();
});

})();
//# sourceMappingURL=institution-carrossel.js.map
